	$('.carousel').carousel({
	  interval: 5000,
   	  pause: "false"
	});
	$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
});	
});	
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 30) {
        $(".header_sec").addClass("fixed");
    } else {
        $(".header_sec").removeClass("fixed");
    }
});

$(document).ready(function() {
var owl = $('.carocelsec .owl-carousel');
  owl.owlCarousel({
    loop:true,
    margin: 30,
    dotsEach: false,
    nav: true,
    autoplay: false,
    responsive: {
       0:{
            items:1,
       },
       480:{
            items:1,
       },
       575:{
            items: 2,
       },
       
       767:{
            items: 2,
        },
        992:{
            items: 3,
        },
        1200:{
            items: 4,
        }
    }
  });
});